/** 보증서 템플릿(1728×2464) 위 절대 좌표 — % 단위 */
export const WHEEL_PREMIUM_WARRANTY_OVERLAY = {
  carModel: { top: '20.1%', left: '25.5%', width: '24%' },
  carNumber: { top: '20.1%', left: '62.8%', width: '24%' },
  contact: { top: '22.5%', left: '25.5%', width: '68%' },

  positions: {
    FL: { top: '24.7%', left: '29.7%' },
    RL: { top: '24.7%', left: '41.4%' },
    FR: { top: '24.7%', left: '53.0%' },
    RR: { top: '24.7%', left: '64.7%' },
  },

  wheelTypes: {
    PAINTED: { top: '27.1%', left: '27.1%' },
    SPUTTERING: { top: '27.1%', left: '35.7%' },
    CUTTING: { top: '27.1%', left: '48.6%' },
    CHROME: { top: '27.1%', left: '57.7%' },
    AFTERMARKET_3PC: { top: '27.1%', left: '66.9%' },
    BUFFING: { top: '27.1%', left: '78.5%' },
  },

  /** 2. 자동차 휠 타이어 관리사 인증 — 좌측 자격증 사진란 */
  certImage: { top: '32.6%', left: '18%', width: '22%', height: '9.0%' },

  shopName: { top: '34.5%', left: '54.1%', width: '38%' },
  shopAddress: { top: '36.9%', left: '54.1%', width: '38%' },
  shopPhone: { top: '39.3%', left: '54.1%', width: '38%' },

  dateYear: { top: '87.6%', left: '37.9%', width: '5.6%' },
  dateMonth: { top: '87.6%', left: '47.1%', width: '4.5%' },
  dateDay: { top: '87.6%', left: '55%', width: '4.5%' },

  customerName: { top: '90.8%', left: '65%', width: '24%' },

  /** 한국자동차휠수리복원협회(인) 아래 · 페이지 표시 위 · 가로 가운데 */
  customerCenter: { top: '97.15%', left: '50%', width: 'auto' },
};
